import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Login({ setUser }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignup, setIsSignup] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
  e.preventDefault();

  const url = isSignup
    ? "https://ecommerce-backend-ya7x.onrender.com/api/auth/register"
    : "https://ecommerce-backend-ya7x.onrender.com/api/auth/login";

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await res.json();

  if (!res.ok) {
    alert(data.message || "Error");
    return;
  }

  setUser(data.user);
localStorage.setItem("user", JSON.stringify(data.user)); // add here
navigate("/");
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0d0d0f] px-6 [font-family:'Syne',sans-serif]">
      <link href="https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700&display=swap" rel="stylesheet" />

      <div className="w-full max-w-sm bg-[#141416] border border-white/[0.07] rounded-[10px] p-6 sm:p-8">

        <p className="text-[0.65rem] font-medium tracking-[0.22em] uppercase text-[#6f5bff] mb-3">
          Account
        </p>
        <h2 className="text-2xl font-semibold tracking-tight text-white mb-8">
          {isSignup ? "Create account" : "Welcome back"}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-[0.7rem] font-medium tracking-[0.12em] uppercase text-gray-500">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="john@example.com"
              className="w-full mt-2 bg-[#0d0d0f] border border-white/[0.07] rounded-md px-3 py-2.5
                text-sm text-white placeholder-gray-700
                focus:outline-none focus:border-[#6f5bff]/50
                transition-colors duration-200"
            />
          </div>

          <div>
            <label className="text-[0.7rem] font-medium tracking-[0.12em] uppercase text-gray-500">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              className="w-full mt-2 bg-[#0d0d0f] border border-white/[0.07] rounded-md px-3 py-2.5
                text-sm text-white placeholder-gray-700
                focus:outline-none focus:border-[#6f5bff]/50
                transition-colors duration-200"
            />
          </div>

          <button
            type="submit"
            className="w-full mt-2 py-2.5 text-white text-[0.8rem] font-semibold tracking-[0.04em]
              bg-[#6f5bff] rounded-md hover:bg-[#8472ff] active:scale-[0.98]
              transition-all duration-200 ease-in-out"
          >
            {isSignup ? "Sign Up" : "Login"}
          </button>
        </form>

        <p className="text-[0.7rem] text-gray-600 mt-6 text-center">
          {isSignup ? "Already have an account?" : "Don't have an account?"}{" "}
          <span
            onClick={() => { setIsSignup(!isSignup); setEmail(""); setPassword(""); }}
            className="text-[#8b7dff] cursor-pointer hover:text-[#6f5bff] transition-colors duration-200"
          >
            {isSignup ? "Login" : "Sign Up"}
          </span>
        </p>

      </div>
    </div>
  );
}

export default Login;